/* Privatefun — de aanbevelingen onderaan de productpagina alvast ophalen.

   HET PROBLEEM. <product-recommendations> van het thema begint pas te laden als de sectie
   bijna in beeld komt: de IntersectionObserver in product-recommendations.js staat op
   rootMargin 0px 0px 400px 0px. Tot dat moment staan er vier grijze skeletvakken. Scroll je
   naar beneden terwijl de productfoto's allang staan, dan kom je dus precies aan bij een
   stuk pagina dat nog moet beginnen met laden, en zie je die grijze vlakken verschijnen.
   Op een trage verbinding blijven ze een seconde of langer staan.

   DE OPLOSSING. De sectie hoeft niet te wachten tot je er bent. Het verzoek is klein, komt
   van dezelfde server en is er normaal binnen enkele honderden milliseconden. We geven het
   dus een zetje zodra de pagina klaar is en de browser niets beters te doen heeft. Tegen de
   tijd dat iemand naar beneden scrolt staan de kaarten er al en is er geen skelet te zien.

   HOE WE DAT ZETJE GEVEN. Niet door de component na te bouwen — die haalt de sectie op,
   voegt hem samen met morphSection en houdt zijn eigen cache bij, en dat willen we niet
   dubbel doen. In product-recommendations.js zit een MutationObserver die bij élke
   attribuutwijziging op het element opnieuw #loadRecommendations() aanroept. Eén attribuut
   zetten is dus genoeg; de component doet de rest precies zoals hij het zelf zou doen.

   Mocht het thema die MutationObserver ooit weghalen, dan gebeurt er hier simpelweg niets
   en valt alles terug op het gedrag van vóór dit bestand: de eigen observer van de component
   laadt de sectie alsnog zodra je in de buurt komt. Stuk kan het dus niet.

   De kosten: één extra verzoek per bezochte productpagina, ook als de bezoeker nooit zo ver
   naar beneden scrolt. Shopify cachet dat antwoord, dus dat is het waard. Wil je dat niet,
   zet dan VOORUIT_LADEN hieronder op false; dan blijft alleen de ruimere marge over en begint
   het laden 1500px van tevoren in plaats van 400px.
*/
(function () {
  var VOORUIT_LADEN = true;
  var MARGE = '0px 0px 1500px 0px';

  function zetAan(el) {
    if (el.dataset.pfGezet) return;
    el.dataset.pfGezet = '1';
    if (el.dataset.recommendationsPerformed === 'true') return;
    /* Dit attribuut doet zelf niets. Het bestaat alleen zodat de MutationObserver van de
       component afgaat; zie de uitleg bovenin. */
    el.setAttribute('data-pf-vooruit', String(Date.now()));
  }

  function start() {
    var secties = document.querySelectorAll('product-recommendations');
    if (!secties.length) return;

    for (var i = 0; i < secties.length; i++) {
      var sectie = secties[i];

      if (VOORUIT_LADEN) {
        if (window.requestIdleCallback) {
          (function (el) {
            window.requestIdleCallback(function () { zetAan(el); }, { timeout: 2500 });
          })(sectie);
        } else {
          (function (el) {
            setTimeout(function () { zetAan(el); }, 1200);
          })(sectie);
        }
        continue;
      }

      if (window.IntersectionObserver) {
        (function (el) {
          var waarnemer = new IntersectionObserver(function (entries, obs) {
            if (entries[0] && entries[0].isIntersecting) {
              obs.disconnect();
              zetAan(el);
            }
          }, { rootMargin: MARGE });
          waarnemer.observe(el);
        })(sectie);
      }
    }
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }
})();